import { useEffect, useState } from "react";
import { formatFCFA, formatDate } from "@/lib/format";
import Modal from "@/components/Modal";
import api from "@/lib/api";
import { Loader } from "@/components/common";

export default function LedgerModal({ proId, name, onClose }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => { api.get(`/admin/pro-ledger/${proId}`).then((r) => setData(r.data)).catch(() => setError(true)); }, [proId]);
  return (
    <Modal title={`Grand livre — ${name}`} onClose={onClose} testid="ledger-modal" size="lg">
      {error ? <p className="text-sm text-red-500 py-6 text-center">Impossible de charger le grand livre. Réessayez.</p>
        : !data ? <Loader /> : <LedgerTable data={data} />}
    </Modal>
  );
}

export function LedgerTable({ data, dark }) {
  const head = dark ? "text-slate-400" : "text-slate-500";
  const border = dark ? "border-slate-700" : "border-slate-100";
  return (
    <div>
      <div className="grid grid-cols-3 gap-2 mb-3 text-center">
        <Kpi label="Gagné" value={formatFCFA(data.earned)} dark={dark} />
        <Kpi label="Payé" value={formatFCFA(data.paid)} dark={dark} color="text-green-500" />
        <Kpi label="Solde dû" value={formatFCFA(data.remaining)} dark={dark} color="text-[#E08B00]" />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className={`${head} text-xs uppercase`}><tr>
            <th className="text-left py-2 pr-2">Date</th><th className="text-left py-2 pr-2">Libellé</th>
            <th className="text-right py-2 px-2">Gain</th><th className="text-right py-2 px-2">Paiement</th>
            <th className="text-right py-2 pl-2">Solde</th>
          </tr></thead>
          <tbody>
            {data.entries.length === 0 && <tr><td colSpan={5} className="py-5 text-center text-slate-400">Aucune opération.</td></tr>}
            {data.entries.map((e, i) => (
              <tr key={i} className={`border-t ${border}`} data-testid={`ledger-row-${i}`}>
                <td className="py-2 pr-2 whitespace-nowrap text-slate-400">{e.date ? formatDate(e.date) : "—"}</td>
                <td className="py-2 pr-2">{e.label}</td>
                <td className="py-2 px-2 text-right font-num text-green-600">{e.gain ? formatFCFA(e.gain) : "—"}</td>
                <td className="py-2 px-2 text-right font-num text-[#C85A32]">{e.payment ? formatFCFA(e.payment) : "—"}</td>
                <td className="py-2 pl-2 text-right font-num font-bold">{formatFCFA(e.solde)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Kpi({ label, value, color, dark }) {
  return (
    <div className={`rounded-lg p-2 ${dark ? "bg-[#1F2937] border border-slate-700" : "bg-slate-50"}`}>
      <p className={`font-num font-bold ${color || (dark ? "text-white" : "text-slate-800")}`}>{value}</p>
      <p className="text-[11px] text-slate-400">{label}</p>
    </div>
  );
}
